import { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import Header from "./components/header";
import HeroSection from "./components/hero";
import styles from "./styles/footer.module.scss";
import { translations } from "./translation";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import image from "./assets/images/brain.jpg";
import image2 from "./assets/images/medicalChallenge.jpg";
import image3 from "./assets/images/solution.jpg";
import image4 from "./assets/images/baby.jpg";
import pharma from "./assets/images/pharmaceuticals.jpg";
import phases from "./assets/images/phases.jpg";
import gdpr from "./assets/images/GDPR.jpg";
import mobile from "./assets/images/mobile_app.jpg";
import inside from "./assets/images/whats_inside.jpg";
import collaborators from "./assets/images/collaborators.jpg";
import investors from "./assets/images/investors.jpg";
import emailjs from "emailjs-com";
import contactUs from "./assets/images/contact_us.jpg";
import dravetUKLogo from "./assets/images/dravet_UK_logo.png";
import inceLogo from "./assets/images/fince_logo2.jpg";
import lgsLogo from "./assets/images/LGS_logo.jpg";
import dravetEsLogo from "./assets/images/dravetES_logo.png";
import ucmLogo from "./assets/images/UCM_logo2.jpg";
import pennsieveLogo from "./assets/images/Pennsieve_logo.png";
import androidQR from "./assets/images/AndroidQR.png";
import iosQR from "./assets/images/IosQR.png";

function App() {
	type Language = "en" | "es";
	const [language, setLanguage] = useState<Language>("en");
	const [name, setName] = useState("");
	const [email, setEmail] = useState("");
	const [message, setMessage] = useState("");
	const [status, setStatus] = useState("");
	const [sending, setSending] = useState<boolean>(false);
	const [intervalDuration, setIntervalDuration] = useState<number>(8000);
	const [resetTrigger, setResetTrigger] = useState(false);
	const logos: any[] = [inceLogo, dravetEsLogo, dravetUKLogo, lgsLogo, ucmLogo, pennsieveLogo];

	const getLanguage = (currentLanguage: Language) => {
		setLanguage(currentLanguage);
	};

	const videoUrl: string = "https://demo-newtoms.s3.us-east-1.amazonaws.com/APK+Consumer+Pro/medicalChallengeVid.mov";
	const videoUrl2: string = "https://demo-newtoms.s3.us-east-1.amazonaws.com/APK+Consumer+Pro/contact_us_vid.mov";

	const t = translations[language];
	const [currentIndex, setCurrentIndex] = useState(0);
	const points = t.collaboratorsSectionPoints;

	const handleSubmit = (e: any) => {
		e.preventDefault();

		const templateParams = {
			message,
			email,
			name,
		};

		setSending(true);

		emailjs.send("service_3pdt1lg", "template_fk8zh7m", templateParams, "KONJSWOPVeu405x2E").then(
			(response) => {
				setStatus("Message sent successfully!");
				console.log(status);
				setMessage("");
				setName("");
				setEmail("");
				setSending(false);
				toast.success("Message sent successfully!");
			},
			(error) => {
				setStatus("Failed to send message, please try again.");
				console.log(status);
				setSending(false);
				toast.success("Failed to send message, please try again.");
			},
		);
	};

	const goPrev = () => {
		setCurrentIndex((prevIndex) => (prevIndex === 0 ? points.length - 1 : prevIndex - 1));
		setIntervalDuration(8000);
		setResetTrigger((prev) => !prev);
	};

	const goNext = () => {
		setCurrentIndex((prevIndex) => (prevIndex === points.length - 1 ? 0 : prevIndex + 1));
		setIntervalDuration(8000);
		setResetTrigger((prev) => !prev);
	};

	useEffect(() => {
		const intervalId = setInterval(() => {
			setCurrentIndex((prevIndex) => (prevIndex === points.length - 1 ? 0 : prevIndex + 1));
		}, intervalDuration);

		return () => clearInterval(intervalId);
	}, [points.length, intervalDuration, resetTrigger]);

	return (
		<Router>
			<div className="main-container">
				<Header getLanguage={getLanguage} />
				<HeroSection language={language} />

				<div className="main-content text-center text-md-start">
					{/* <section className="section-container p-3 p-md-5" id="platform">
						<h2 className="section-title text-center mb-5">{t.platformSectionTitle}</h2>
						<p className="section-text">{t.platformSectionContent}</p>

						<div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center mb-4 mb-md-0">
								<img className="section-img img-fluid rounded shadow" src={image} alt="Platform illustration" />
							</div>

							<div className="col-md-6 d-flex justify-content-center flex-column">
								<h5 className="section-subtitle mb-3 text-center">{t.platformSectionSubtitle}</h5>
								<ul className="section-list">
									{t.platformSectionPoints.map((point, i) => (
										<li key={i}>{point}</li>
									))}
								</ul>
							</div>
						</div>
					</section> */}

					<section className="section-container p-3 p-md-5" id="clinical-challenge">
						<h2 className="section-title text-center mb-4 mt-3">{t.clinicalSectionTitle}</h2>

						<div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center mb-4 mb-md-0">
								<img className="section-img img-fluid rounded shadow" src={image4} alt="Clinical challenge illustration" />
							</div>
							<div className="col-md-6 d-flex justify-content-center flex-column">
								<h5 className="section-subtitle mb-3 text-center">{t.clinicalSectionSubtitle}</h5>
								<ul className="section-list">
									{t.clinicalSectionPoints.map((point, i) => (
										<li key={i}>{point}</li>
									))}
								</ul>
							</div>
						</div>
						<p className="section-text">{t.clinicalSectionContent}</p>
					</section>

					<section className="section-container p-3 p-md-5 bg-alternate" id="solution">
						<h2 className="section-title text-center mb-4">{t.solutionSectionTitle}</h2>

						<div className="row align-items-stretch">
							{/* <div className="col-md-6 d-flex flex-column mb-4 mb-md-0 justify-content-around">
								<img className="section-img img-fluid rounded shadow" src={image3} alt="Solution illustration" />
								<video className="solution-section-video" autoPlay muted loop playsInline>
									<source src={videoUrl} type="video/mp4" />
								</video>
								<img className="section-img img-fluid rounded shadow" src={image2} alt="Solution illustration" />
							</div> */}
							<div className="col d-flex justify-content-center flex-column">
								<div className="solution-video-container d-flex justify-content-center">
									<video className="solution-section-video mb-4" autoPlay muted loop playsInline>
										<source src={videoUrl} type="video/mp4" />
									</video>
								</div>
								<p className="section-text mb-4">
									<span className="fw-bold">Epilexia </span>
									{t.solutionSectionContent}
								</p>
								<h5 className="section-subtitle mb-3 text-center">{t.solutionSectionSubTitle1}</h5>
								<ul className="section-list">
									{t.solutionSectionPoints1.map((point, i) => (
										<li key={i}>{point}</li>
									))}
								</ul>
								<h5 className="section-subtitle mb-3 text-center">{t.solutionSectionSubTitle2}</h5>
								<ul className="section-list">
									{t.solutionSectionPoints2.map((point, i) => (
										<li key={i}>{point}</li>
									))}
								</ul>
								<h5 className="section-subtitle mb-3 text-center">{t.solutionSectionSubTitle3}</h5>
								<p className="section-text ">{t.solutionSectionSubtitleText1}</p>
								<ul className="section-list">
									{t.solutionSectionPoints3.map((point, i) => (
										<li key={i}>{point}</li>
									))}
								</ul>
								<p className="section-text  ">{t.solutionSectionSubtitleText2}</p>
								<h5 className="section-subtitle mb-3 text-center">{t.solutionSectionSubTitle4}</h5>
								<ul className="section-list">
									{t.solutionSectionPoints4.map((point, i) => (
										<li key={i}>{point}</li>
									))}
								</ul>
							</div>
						</div>
					</section>

					{/* <section className="section-container p-3 p-md-5 bg-alternate" id="inside">
						<h2 className="section-title text-center mb-4">{t.insideSectionTitle}</h2>
						<p className="section-text mb-4">{t.insideSectionContent}</p>
						<div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center mb-4 mb-md-0">
								<img className="section-img img-fluid rounded shadow" src={inside} alt="inside illustration" />
							</div>
							<ul className="col-md-6 section-list">
								{t.insideSectionPoints.map((text, i) => (
									<li key={i} className="mb-2">
										{text}
									</li>
								))}
							</ul>
						</div>
					</section> */}

					{/* <section className="section-container p-3 p-md-5 bg-alternate" id="clinicians">
						<h2 className="section-title text-center mb-4">{t.cliniciansSectionTitle}</h2>
						<div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center mb-4 mb-md-0">
								<img className="section-img img-fluid rounded shadow" src={image2} alt="Clinicians illustration" />
							</div>
							<ul className="col-md-6 section-list">
								{t.clicniciandSectionContent.map((text, i) => (
									<li key={i} className="mb-2">
										{text}
									</li>
								))}
							</ul>
						</div>
					</section> */}

					{/* <section className="section-container p-3 p-md-5" id="researshers">
						<h2 className="section-title text-center mb-4">{t.reasearchersSectionTitle}</h2>
						<div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center mb-4 mb-md-0 ">
								<video className="section-video" autoPlay muted loop playsInline>
									<source src={videoUrl} type="video/mp4" />
								</video>
							</div>
							<ul className="section-list col-md-6">
								{t.researchersSectionContent.map((text, i) => (
									<li key={i} className="mb-2">
										{text}
									</li>
								))}
							</ul>
						</div>
					</section> */}

					{/* <section className="section-container p-3 p-md-5 " id="pharmaceutical">
						<h2 className="section-title text-center mb-4">{t.pharmaSectionTitle}</h2>
						<p className="section-text mb-4">{t.pharmaSectionContent}</p>

						<div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center mb-4 mb-md-0">
								<img className="section-img img-fluid rounded shadow" src={pharma} alt="Clinicians illustration" />
							</div>
							<div className="col-md-6 d-flex justify-content-center flex-column">
								<h5 className="section-subtitle mb-3 text-center">{t.pharmaSectionSubtitle1}</h5>
								<ul className="section-list">
									{t.pharmaSectionPoints.map((point, i) => (
										<li key={i} className="mb-2">
											{point}
										</li>
									))}
								</ul>
							</div>
						</div>

						<p className="section-text mb-2 mt-3">{t.pharmaSectionSubtitle2}</p>
						<p className="section-note">{t.pharmaSectionContent2}</p>
					</section> */}

					{/* <section className="section-container p-3 p-md-5 bg-alternate" id="phases">
						<h2 className="section-title text-center mb-4">{t.phasesSectionTitle}</h2>
						<p className="section-text mb-4">{t.phasesSectionContent}</p>

						<div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center mb-4 mb-md-0">
								<img className="section-img img-fluid rounded shadow" src={phases} alt="Clinicians illustration" />
							</div>
							<div className="col-md-6 d-flex justify-content-center flex-column">
								<h5 className="section-subtitle mb-3 text-center">{t.phasesSectionSubtitle}</h5>
								<ol className="section-list">
									{t.phasesSectionPoints.map((point, i) => (
										<li key={i} className="mb-2">
											{point}
										</li>
									))}
								</ol>
							</div>
						</div>
					</section> */}

					<section className="section-container p-3 p-md-5" id="mobile">
						<h2 className="section-title text-center">{t.mobileSectionTitle}</h2>
						<p className="section-text mb-4">{t.mobileSectionContent1}</p>

						<div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center  mb-4 mb-md-0">
								<img className="section-img img-fluid rounded shadow" src={mobile} alt="mobile illustration" />
							</div>
							<div className="col-md-6 d-flex justify-content-center flex-column">
								<h5 className="section-subtitle mb-3 text-center">{t.mobileSectionSubtitle}</h5>
								<ul className="section-list">
									{t.mobileSectionPoints.map((point, i) => (
										<li key={i} className="mb-2">
											{point}
											{i === t.mobileSectionPoints.length - 1 && (
												<ul className="section-list">
													{t.mobileSectionPoints2.map((point, i) => (
														<li key={i} className="ms-5 mb-2">
															{point}
														</li>
													))}
												</ul>
											)}
										</li>
									))}
								</ul>
							</div>
						</div>
						<p className="section-text mt-4">{t.mobileSectionContent2}</p>
						<div className="row justify-content-around mt-4">
							<div className="text-center">
								<h4 className="col'12">{t.mobileSectionDownloadAppTitle}</h4>
							</div>
							<img className={`col py-2 ${styles["qr-img"]}`} src={androidQR} alt="" />
							<img className={`col py-2 ${styles["qr-img"]}`} src={iosQR} alt="" />
						</div>
					</section>

					<section className="section-container p-3 p-md-5 bg-alternate" id="ethics">
						<h2 className="section-title text-center mb-4">{t.ethicsSectionTitle}</h2>
						<p className="section-text mb-4">{t.ethicsSectionContent1}</p>
						<div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center mb-4 mb-md-0">
								<img className="section-img img-fluid rounded shadow" src={gdpr} alt="Ethics illustration" />
							</div>
							<div className="col-md-6 d-flex justify-content-center flex-column">
								<h5 className="section-subtitle mb-3 text-center">{t.ethicsSectionSubTitle}</h5>
								<ul className="section-list">
									{t.ethicsSectionPoints.map((point, i) => (
										<li key={i} className="mb-2">
											{point}
										</li>
									))}
								</ul>
							</div>
						</div>
						<p className="section-text mt-4">{t.ethicsSectionContent2}</p>
					</section>

					<section className="section-container p-3 p-md-5 " id="collaborators">
						<h2 className="section-title text-center">{t.collaboratorsSectionTitle}</h2>
						<p className="section-text">{t.collaboratorsSectionContent}</p>
						{/* new row */}
						<div className="row justify-content-center mt-4 mb-4 align-items-center">
							<div className="col-12 d-flex justify-content-center mb-3">
								<img className="collabLogo" src={logos[currentIndex]} alt={`Logo ${currentIndex + 1}`} />
							</div>
							<button className="btn btn-outline-primary col-auto" onClick={goPrev} aria-label="Previous message">
								&#8592;
							</button>

							<div className="col text-center">
								<p className="m-0">
									<span className=" fw-bold">{t.foundationNames[currentIndex]}</span>
									{t.collaboratorsSectionPoints[currentIndex]}
								</p>
							</div>

							<button className="btn btn-outline-primary col-auto" onClick={goNext} aria-label="Next message">
								&#8594;
							</button>
						</div>

						{/* <div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center mb-4 mb-md-0">
								<img className="section-img img-fluid rounded shadow" src={collaborators} alt="collaborators illustration" />
							</div>
							<div className="col-md-6 d-flex justify-content-center flex-column">
								<ul className="section-list">
									{t.collaboratorsSectionPoints.map((point, i) => (
										<li key={i} className="mb-2">
											<span className=" fw-bold">{t.foundationNames[i]}</span>
											{point}
										</li>
									))}
								</ul>
							</div>
						</div> */}
					</section>

					<section className="section-container p-3 p-md-5 bg-alternate" id="investors">
						<h2 className="section-title text-center">{t.investorsSectionTitle}</h2>
						<p className="section-text mb-4">{t.investorsSectionContent1}</p>

						<div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center mb-4 mb-md-0">
								<img className="section-img img-fluid rounded shadow" src={investors} alt="Investors illustration" />
							</div>
							<div className="col-md-6 d-flex justify-content-center flex-column">
								<h5 className="section-subtitle mb-3 text-center">{t.investorsSectionSubTitle}</h5>
								<ul className="section-list">
									{t.investorsSectionPoints.map((point, i) => (
										<li key={i} className="mb-2">
											{point}
										</li>
									))}
								</ul>
							</div>
						</div>
						<p className="section-text mt-4">{t.investorsSectionContent2}</p>
					</section>

					{/* contact section */}
					<section className="section-container p-3 p-md-5" id="contact-us">
						<ToastContainer />

						<h2 className="section-title text-center">{t.contactUsSectionTitle}</h2>

						<div className="row align-items-center">
							<div className="col-md-6 d-flex justify-content-center mb-4 mb-md-0">
								{/* <img className="section-img img-fluid rounded shadow" src={contactUs} alt="contact-us illustration" /> */}
								<video className="contactUs-section-video " autoPlay muted loop playsInline>
									<source src={videoUrl2} type="video/mp4" />
								</video>
							</div>
							<div className="col-md-6 d-flex justify-content-center flex-column">
								<form onSubmit={handleSubmit}>
									<div className="mb-3">
										<label htmlFor="name" className="form-label">
											{t.formNameLabel}
										</label>
										<input
											id="name"
											type="text"
											className="form-control"
											value={name}
											onChange={(e) => setName(e.target.value)}
											required
										/>
									</div>

									<div className="mb-3">
										<label htmlFor="email" className="form-label">
											{t.formEmailLabel}
										</label>
										<input
											id="email"
											type="email"
											className="form-control"
											value={email}
											onChange={(e) => setEmail(e.target.value)}
											required
										/>
									</div>

									<div className="mb-3">
										<label htmlFor="message" className="form-label">
											{t.formMessageLabel}
										</label>
										<textarea
											id="message"
											className="form-control"
											rows={5}
											value={message}
											onChange={(e) => setMessage(e.target.value)}
											required
										/>
									</div>

									<button type="submit" className="btn btn-primary" disabled={sending}>
										{sending ? (
											<>
												<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>{" "}
												{t.formButtonSending}
											</>
										) : (
											<>{t.formButton}</>
										)}
									</button>
								</form>
							</div>
						</div>
					</section>
				</div>

				<footer className={`py-4 ${styles["footer"]}`} id="footer">
					<div className="container row w-100 m-auto">
						<div className="col-12 col-md mb-2 mb-md-0 d-flex align-items-center justify-content-center">
							<strong>EpilexIA</strong> &copy; {new Date().getFullYear()}
						</div>
						<div className="col-12 col-md mb-2 mb-md-0 d-flex justify-content-center flex-column align-items-center">
							<p className="mb-1">Podcasts:</p>
							<a
								className=" text-decoration-none"
								href="https://open.spotify.com/episode/13R6yJkxZAfEt7JRFMIuWH?si=d6cb60dfd4964885">
								English Podcast
							</a>
							<a
								className=" text-decoration-none"
								href="https://open.spotify.com/episode/4iGO2Pi5zRPssWfb1C9BPG?si=6f402475efcd4294">
								Podcast en Español
							</a>
						</div>
						<div className="col-12 col-md">
							<div className="text-center md:text-right">
								<p className="mb-1">{t.footerContact}</p>
								<p className="mb-0">
									Email:{" "}
									<a href="mailto:contact@epilexia.com" className="text-decoration-none text-reset">
										winston@epilexia.com
									</a>
								</p>
								<p className="mb-0">
									Phone:{" "}
									<a href="tel:+1234567890" className="text-decoration-none text-reset">
										+1 (678) 736-3022
									</a>
								</p>
							</div>
						</div>
						{/* <div className="col-12 text-center mt-4">
							<h4>Download our app!</h4>
							<div className="row justify-content-around">
								<img className={`col py-2 ${styles["qr-img"]}`} src={androidQR} alt="" />
								<img className={`col py-2 ${styles["qr-img"]}`} src={iosQR} alt="" />
							</div>
						</div> */}
					</div>
				</footer>
			</div>
		</Router>
	);
}

export default App;
